import { Component, Injector, OnInit } from "@angular/core";
import { MessageService } from 'primeng/api';
import { Subject } from "rxjs";

import { FiltroAereo, Trecho } from "src/app/model";
import { BuscaComponent } from "src/app/shared/busca/busca.component";
import { diffInDays } from "src/app/utils/luxon.helper";

export const BUSCA = "busca";
export const ORCAMENTO = "orcamentousuario";
@Component({
    selector: "app-listagem",
    templateUrl: "./listagem.component.html",
    styleUrls: ["./listagem.component.scss"],
    providers: [MessageService],
    standalone: false
})
export class ListagemComponent extends BuscaComponent implements OnInit {
    // Orcamento: Orcamento = new Orcamento();
    FiltroAereo: FiltroAereo = new FiltroAereo();
    eventsSubject: Subject<void> = new Subject<void>();
    Cias: String[] = [];
    reserva = [];
    rating = 5;
    progress: any;
    rangeInput: any;
    orcamentoAereo: any;
    badConditions: any;
    errorMessage: string;
    errorAereo: boolean = false;
    toastShown: boolean = false;

    constructor(
        injector: Injector,
        private messageService: MessageService,
    ) {
        super(injector);
    }

    aba() {
        const currentUrl = this._router.url;

        if (this.route.snapshot.params.tipo != null) {
            return this.route.snapshot.params.tipo;
        } else {
            let x = currentUrl.split("/");
            return x[x.length - 1];
        }
    }

    showErrorToast() {
        this.toastShown = false;
        this.messageService.add({
            key: 'c',
            severity: 'error',
            summary: 'Erro',
            detail: 'Escolha um aéreo antes de continuar',
            life: 5000
        });
    }

    ngOnInit() {
        super.ngOnInit();
        if (this.errorAereo) {
            this.showErrorToast();
        }

        this.cdrChange.detectChanges();
    }

    ngAfterViewInit() {
        super.ngAfterViewInit();
    }

    atualizarOrcamento(event, adicionou) {
        if (this.busca.tipoBusca.beto && this.aba() == "beto-carrero" && adicionou) {
            this.Orcamento.BetoCarreroIngressos.push(event);
        } else if (this.busca.tipoBusca.beto) {
            const indexToRemove = this.Orcamento.BetoCarreroIngressos.findIndex(
                x => x.CodItemIntegrador === event.CodItemIntegrador
            );

            if (indexToRemove !== -1) {
                this.Orcamento.BetoCarreroIngressos.splice(indexToRemove, 1);
            }
        }

        window.sessionStorage.setItem(ORCAMENTO, JSON.stringify(this.Orcamento));

        if (this.busca.primeira && adicionou) {
            window.sessionStorage.setItem(BUSCA, JSON.stringify(this.busca));

            const id = this.route.snapshot.params.id;

            if (this.aba() == "aereo" && id === undefined) {
                this.rotaAvancar();
            }
        }
    }

    rebuscou(busca) {
        this.busca = busca;
        this.busca.primeira = false;
        this.eventsSubject.next(busca);
    }

    // selecionarCia(cia) {
    //     setTimeout(() => {
    //         if (this.ciaSelecionada(cia)) {
    //             this.FiltroAereo.Cias = this.FiltroAereo.Cias.filter((x) => x !== cia);
    //         } else {
    //             this.FiltroAereo.Cias.push(cia);
    //         }

    //         this.refazerBusca(this.busca);
    //     }, 600);
    // }

    // ciaSelecionada(cia) {
    //     return this.FiltroAereo.Cias.indexOf(cia) >= 0;
    // }

    rotaAvancar() {
        const tipo = this.aba();
        switch (tipo) {
            case "aereo":
                if (this.busca.tipoBusca.hotel) {
                    return this.rota("hotel");
                }
                if (this.busca.tipoBusca.ticket) {
                    return this.rota("servico");
                }
                if (this.busca.tipoBusca.carro) {
                    return this.rota("carro");
                }
                if (this.busca.tipoBusca.servicoExclusivo) {
                    return this.rota("servicoexclusivos");
                }
                if (this.busca.tipoBusca.beto) {
                    return this.rota("beto-carrero");
                }
                if (this.busca.tipoBusca.circuito) {
                    return this.rota("circuito");
                }

                return this.rota("revisa-orcamento");
            case "hotel":
                if (this.busca.tipoBusca.ticket) {
                    return this.rota("servico");
                }
                if (this.busca.tipoBusca.carro) {
                    return this.rota("carro");
                }
                if (this.busca.tipoBusca.servicoExclusivo) {
                    return this.rota("servicoexclusivos");
                }
                if (this.busca.tipoBusca.beto) {
                    return this.rota("beto-carrero");
                }
                if (this.busca.tipoBusca.circuito) {
                    return this.rota("circuito");
                }

                return this.rota("revisa-orcamento");
            case "servico":
                if (this.busca.tipoBusca.carro) {
                    return this.rota("carro");
                }
                if (this.busca.tipoBusca.servicoExclusivo) {
                    return this.rota("servicoexclusivos");
                }
                if (this.busca.tipoBusca.beto) {
                    return this.rota("beto-carrero");
                }
                if (this.busca.tipoBusca.circuito) {
                    return this.rota("circuito");
                }

                return this.rota("revisa-orcamento");
            case "carro":
                if (this.busca.tipoBusca.servicoExclusivo) {
                    return this.rota("servicoexclusivos");
                }
                if (this.busca.tipoBusca.beto) {
                    return this.rota("beto-carrero");
                }
                if (this.busca.tipoBusca.circuito) {
                    return this.rota("circuito");
                }

                return this.rota("revisa-orcamento");
            case "servicoexclusivos":
                if (this.busca.tipoBusca.beto) {
                    return this.rota("beto-carrero");
                }
                if (this.busca.tipoBusca.circuito) {
                    return this.rota("circuito");
                }

                return this.rota("revisa-orcamento");
            case "beto-carrero":
                if (this.busca.tipoBusca.circuito) {
                    return this.rota("circuito");
                }

                return this.rota("revisa-orcamento");
            case "circuito":
                return this.rota("revisa-orcamento");
        }
    }

    rotaAnterior() {
        const tipo = this.aba();
        switch (tipo) {
            case "revisa-orcamento":
                if (this.busca.tipoBusca.circuito) {
                    return this.rota("circuito");
                }
                if (this.busca.tipoBusca.beto) {
                    return this.rota("beto-carrero");
                }
                if (this.busca.tipoBusca.servicoExclusivo) {
                    return this.rota("servicoexclusivos");
                }
                if (this.busca.tipoBusca.carro) {
                    return this.rota("carro");
                }
                if (this.busca.tipoBusca.ticket) {
                    return this.rota("servico");
                }
                if (this.busca.tipoBusca.hotel) {
                    return this.rota("hotel");
                }

                return this.rota("aereo");
            case "circuito":
                if (this.busca.tipoBusca.beto) {
                    return this.rota("beto-carrero");
                }
                if (this.busca.tipoBusca.servicoExclusivo) {
                    return this.rota("servicoexclusivos");
                }
                if (this.busca.tipoBusca.carro) {
                    return this.rota("carro");
                }
                if (this.busca.tipoBusca.ticket) {
                    return this.rota("servico");
                }
                if (this.busca.tipoBusca.hotel) {
                    return this.rota("hotel");
                }

                return this.rota("aereo");
            case "beto-carrero":
                if (this.busca.tipoBusca.servicoExclusivo) {
                    return this.rota("servicoexclusivos");
                }
                if (this.busca.tipoBusca.carro) {
                    return this.rota("carro");
                }
                if (this.busca.tipoBusca.ticket) {
                    return this.rota("servico");
                }
                if (this.busca.tipoBusca.hotel) {
                    return this.rota("hotel");
                }

                return this.rota("aereo");
            case "servicoexclusivos":
                if (this.busca.tipoBusca.carro) {
                    return this.rota("carro");
                }
                if (this.busca.tipoBusca.ticket) {
                    return this.rota("servico");
                }
                if (this.busca.tipoBusca.hotel) {
                    return this.rota("hotel");
                }

                return this.rota("aereo");
            case "carro":
                if (this.busca.tipoBusca.ticket) {
                    return this.rota("ticket");
                }
                if (this.busca.tipoBusca.hotel) {
                    return this.rota("hotel");
                }

                return this.rota("aereo");
            case "servico":
                if (this.busca.tipoBusca.hotel) {
                    return this.rota("hotel");
                }
                
                return this.rota("aereo");
            case "hotel":
                return this.rota("aereo");
        }
    }

    rota(texto) {
        if (this._router.url.includes("adicionar")) {
            this.busca.novoOrcamento = false;
            this.busca.ReservaId = this.route.snapshot.params.id;
        } else {
            // Garantir que em rotas de listagem simples não persista ReservaId
            this.busca.ReservaId = 0;
            this.busca.novoOrcamento = true;
        }

        if (this.busca.novoOrcamento) {
            this._router.navigate([`listas/${texto}`]);
        } else {
            this._router.navigate([`adicionar/${this.busca.ReservaId}/${texto}`]);
        }
    }

    qtdNoites(): number {
        this.busca.nrnoites = 0;
        this.busca.nrnoites = diffInDays(this.busca.trechos[0].dataIda, this.busca.trechos[0].dataVolta);
        return this.busca.nrnoites;
    }

    setDataIdaEmitter(dataEmitter: { event: any, trechos: Trecho[], indice: number }) {
        this.setDataIda(dataEmitter.event, dataEmitter.trechos, dataEmitter.indice);
    }

    setDataVoltaEmitter(dataEmitter: { event: any, trechos: Trecho[], indice: number }) {
        this.setDataVolta(dataEmitter.event, dataEmitter.trechos, dataEmitter.indice);
    }
}
